<ion-content [scrollY]="false">
  <app-scroll>
    <main translate="">
      <figure class="animated-icon">
        <ng-lottie height="150px" [options]="options"></ng-lottie>
      </figure>
      <p class="title">
        <strong>{{ 'ShortURL.heading' | translate }}</strong>
      </p>
      <p class="mt-half"></p>

      <p class="message">
        <strong> {{ 'ShortURL.message' | translate }} </strong>
        <br />
        <small>{{ 'ShortURL.note' | translate }}</small>
      </p>
      <ion-button class="wg-btn-large" expand="block" fill="solid" size="large" color="primary" routerLink="/landing">
        {{ 'ShortURL.goHome' | translate }}
      </ion-button>
    </main>
  </app-scroll>
</ion-content>
